import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, Clock } from 'lucide-react';
import { treatments, clinicInfo } from '../data/mock';

const Treatments = () => {
  const [selectedTreatment, setSelectedTreatment] = useState(null);

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding-small" style={{
        background: 'linear-gradient(to bottom, var(--bg-primary) 0%, var(--bg-secondary) 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Tratamentos Especializados
          </h1>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto', color: 'var(--text-secondary)' }}>
            Soluções completas em odontologia com tecnologia de ponta e atendimento humanizado.
          </p>
        </div>
      </section>

      {/* Treatments List */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            {treatments.map((treatment, index) => (
              <div key={treatment.id} style={{
                border: '1px solid var(--border-light)',
                borderRadius: '0px',
                background: index % 2 === 0 ? 'var(--bg-primary)' : 'var(--bg-secondary)',
                overflow: 'hidden'
              }}>
                <div className="grid-two-column" style={{ gap: '0' }}>
                  <div style={{ padding: '48px' }}>
                    <h2 className="heading-1" style={{ marginBottom: '16px' }}>
                      {treatment.title}
                    </h2>
                    <p className="body-large" style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
                      {treatment.fullDescription}
                    </p>

                    <div style={{ marginBottom: '24px' }}>
                      <h3 className="heading-3" style={{ marginBottom: '12px' }}>Quando é indicado</h3>
                      <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                        {treatment.indication}
                      </p>
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                      <h3 className="heading-3" style={{ marginBottom: '12px' }}>Benefícios</h3>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {treatment.benefits.map((benefit, idx) => (
                          <li key={idx} style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                            <CheckCircle size={16} style={{ color: 'var(--text-primary)', marginTop: '2px', flexShrink: 0 }} />
                            <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>{benefit}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div style={{ marginBottom: '32px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <Clock size={16} style={{ color: 'var(--text-primary)' }} />
                      <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                        <strong>Duração:</strong> {treatment.duration}
                      </span>
                    </div>

                    <a 
                      href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-primary"
                    >
                      Agendar Avaliação
                    </a>
                  </div>

                  <div style={{
                    background: 'var(--bg-secondary)',
                    minHeight: '400px',
                    border: '1px solid var(--border-light)'
                  }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding" style={{
        background: 'var(--bg-secondary)',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
            Pronto para transformar seu sorriso?
          </h2>
          <p className="body-large" style={{ marginBottom: '40px', color: 'var(--text-secondary)' }}>
            Agende uma avaliação e descubra qual tratamento é ideal para você.
          </p>
          <a 
            href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Falar no WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
};

export default Treatments;